<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>And the drums keep beating</i> …</p>
<p class="ded1"><i>And the books keep coming</i> …</p>
<p class="ded1"><i>And Tek continues to multiply</i>.</p>
<p class="ded2"><i>From a modest beginning in October 1989 to now, the tidal wave that is Tek contains six novels, twenty-four comic books, four movies, and now, the Holy Grail of popular literature, a</i> TekWar <i>television series on the USA Network</i>.</p>
<p class="ded2"><i>Obeisance must be paid to Ron Goulart, Carmen LaVia, Susan Allison, Mary Jo Fernandez, Ivy Fischer Stone and to Sterling and Martika, my two Dobies, who have guarded the Tek books and have a couple of dog-eared copies themselves</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1f0efb68